export class MissingUnenrollmentReasonsError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'MissingUnenrollmentReasonsError'
  }
}
